import { jsx as _jsx } from "react/jsx-runtime";
import { ColumnAlignmentStyles } from '../Table.interface';
export const TableCellEditable = ({ alignment, isEditing, children, onEdit }) => {
    const className = `table-cell-editable ${ColumnAlignmentStyles[alignment]}`;
    return (_jsx("div", { className: className, onClick: (e) => e.stopPropagation(), onPointerDown: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), onKeyUp: (e) => e.stopPropagation(), children: isEditing ? (children) : (_jsx("button", { className: "table-cell-editable-button", onClick: onEdit, children: children })) }));
};
